export const personalData = {
  name: "Mitch Brey",
  title: "Operations Manager & IT Leader",
  tagline: "Driving community engagement, data and workflow optimization, and technology strategy in mission-driven organizations.",
  bio: [
    "Mitch Brey is a nonprofit professional and sustainability advocate with a career centered on expanding access to clean energy, supporting people with disabilities, and strengthening community‑based organizations. He graduated with a degree in biochemistry at the University of Wisconsin–Madison before shifting from research to hands‑on work aimed at improving people’s everyday lives.",
    "Mitch spent three years as a case manager for adults with developmental disabilities at Community Living Connections before transitioning into the clean energy sector, where he worked with Focus on Energy conducting residential energy assessments. He later served as a campaign organizer with RePower Madison, helping residents engage more directly in local energy planning and advocating for a faster transition to renewable energy.",
    "Mitch joined the Wisconsin Council of the Blind & Vision Impaired in 2019, where he has played a key role in keeping the organization running smoothly. From managing front‑desk staff and supporting technology needs to assisting in the Sharper Vision Store and contributing to advocacy efforts, Mitch has become one of the essential people who keep the Council humming day in and day out.",
    "Across his roles, Mitch is known for his ability to problem‑solve, work collaboratively, and approach challenges from multiple perspectives. He brings experience from nonprofits of all sizes, along with a deep commitment to equity, sustainability, and community empowerment—values that guide his interest in net‑zero affordable housing development."
  ],
  experience: [
    {
      role: "Board President",
      company: "Sunny Side Development",
      period: "Current",
      description: "Leading strategic initiatives for affordable housing development with a focus on net-zero sustainability.",
      achievements: []
    },
    {
      role: "Operations Manager",
      company: "Wisconsin Council of the Blind & Visually Impaired",
      period: "Jan 2019 – Present",
      description: "Oversee IT operations, property management, and technology strategy. Administer Microsoft 365, Google for Nonprofits, and WordPress.",
      achievements: [
        "Migrated organization from QuickBooks Desktop to QuickBooks Online and implemented Lightspeed POS.",
        "Designed automated workflows using Google Forms and Sheets for timesheets, call logs, and expense reporting.",
        "Led cybersecurity upgrades: cloud migration, MFA rollout, conditional access policies, and endpoint protection.",
        "Managed migrations from Windows 10 to 11, Active Directory to Entra ID, and on-prem phone system to VOIP.",
        "Facilitated AI adoption by building systems and training staff on effective tools and safety."
      ]
    },
    {
      role: "Campaign Director",
      company: "RePower Madison",
      period: "5 Years",
      description: "Directed clean energy advocacy campaign; managed events, communications, and stakeholder engagement.",
      achievements: [
        "Implemented digital platforms and analytics to track proposals and inform outreach strategies.",
        "Helped residents engage more directly in local energy planning."
      ]
    },
    {
      role: "Installation Technician",
      company: "Conservation Services Group",
      period: "3 Years",
      description: "Performed residential energy audits and installed efficiency measures; educated homeowners on programs and incentives.",
      achievements: [
        "Data collection and customer service"
      ]
    },
    {
      role: "Community Support Manager",
      company: "Community Living Connections",
      period: "3 Years",
      description: "Provided case management and residential support for individuals with developmental disabilities.",
      achievements: [
        "Supervised staff and ensured quality service."
      ]
    }
  ],
  education: {
    degree: "Bachelor of Science in Natural Sciences, Major in Biochemistry",
    school: "University of Wisconsin–Madison"
  },
  skills: [
    "IT Leadership & Strategy",
    "AI Systems & Policy Development",
    "Cybersecurity & MFA",
    "Payment Processing & POS",
    "Microsoft 365 & Google Workspace",
    "Data Analytics & Visualization",
    "Workflow Automation",
    "Change Management"
  ],
  interests: [
    "Running",
    "Gardening",
    "Board Games",
    "Community Festivals",
    "Farmers' Markets"
  ],
  contact: {
    email: "mitchbrey@gmail.com",
    linkedin: "https://www.linkedin.com/in/mitch-brey/",
    location: "Madison, Wisconsin 53718",
    phone: "(920) 323-9585"
  }
};
